import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/logo.svg';

export default function SiteFooter() {
  const { t } = useTranslation();

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Column 1: Logo & Description */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <Link to="/" className="flex items-center">
                <div className="flex items-center space-x-2.5"><img src={logo} alt="AtlasSlicer 2D Logo" className="h-8 w-8 rounded-lg shadow-sm object-contain" /><span className="text-lg font-bold text-gray-900 dark:text-white">AtlasSlicer 2D</span></div>
              </Link>
            </div>
            <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Column 2: Services */}
          <div>
            <h5 className="mb-2 font-medium text-orange-500 dark:text-orange-400 text-xs uppercase tracking-wider">
              {t('footer.services')}
            </h5>
            <ul className="space-y-2 text-xs">
              <li>
                <a 
                  href="mailto:support@atlasslicer.com" 
                  className="text-gray-500 hover:text-orange-500 dark:text-gray-400 dark:hover:text-orange-400 transition-colors flex items-center gap-1.5"
                >
                  <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  {t('footer.contactUs')}
                </a>
              </li>
              <li>
                <span className="text-gray-400 dark:text-gray-500 text-[11px] block break-all">
                  support@atlasslicer.com
                </span>
              </li>
            </ul>
          </div>

          {/* Column 3: About & Legal */}
          <div>
            <h5 className="mb-2 font-medium text-orange-500 dark:text-orange-400 text-xs uppercase tracking-wider">
              {t('footer.about')}
            </h5>
            <ul className="space-y-1.5 text-xs">
              <li>
                <Link to="/user-agreement" className="text-gray-500 hover:text-orange-500 dark:text-gray-400 dark:hover:text-orange-400 transition-colors">
                  {t('footer.userAgreement')}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-500 hover:text-orange-500 dark:text-gray-400 dark:hover:text-orange-400 transition-colors">
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-gray-500 hover:text-orange-500 dark:text-gray-400 dark:hover:text-orange-400 transition-colors">
                  {t('footer.refundPolicy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Support Card */}
          <div className="bg-gray-50 dark:bg-gray-800/60 p-4 rounded-xl border border-gray-100 dark:border-gray-800">
            <h5 className="mb-1 font-semibold text-gray-900 dark:text-white text-xs">
              {t('footer.supportTitle', 'Contact Support')}
            </h5>
            <p className="text-[11px] text-gray-500 dark:text-gray-400 mb-2">
              {t('footer.supportDesc', 'Have questions about using the product or your purchase? Reach out anytime:')}
            </p>
            <a 
              href="mailto:support@atlasslicer.com" 
              className="text-xs font-mono font-medium text-orange-600 dark:text-orange-400 hover:underline block break-all"
            >
              support@atlasslicer.com
            </a>
          </div>
        </div>

        {/* Bottom Copyright & Support Note */}
        <div className="mt-8 border-t border-gray-200 dark:border-gray-800 pt-6 text-center text-xs text-gray-400 dark:text-gray-500">
          <p>
            {t('footer.copyright')}
          </p>
          <p className="mt-1.5 text-[11px]">
            {t('footer.customerSupport', 'Customer Support')}: <a href="mailto:support@atlasslicer.com" className="text-gray-500 dark:text-gray-400 hover:text-orange-500 underline">support@atlasslicer.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
} 